import React, { useEffect, useState } from 'react';

import { Map, Marker } from 'pigeon-maps';
import { osm } from 'pigeon-maps/providers';
import PropTypes from 'prop-types';

import st from './MapCell.module.sass';

export const MapCell = ({ value, height }) => {
  const [position, setPosition] = useState([null, null]);

  useEffect(() => {
    if (!value) return;

    setPosition([+value.latitude, +value.longitude]);
  }, [value?.latitude, value?.longitude]);

  return (
    <div className={st.Map}>
      <div className={st.MapContent}>
        <Map
          attribution={false}
          center={position}
          defaultZoom={18}
          height={height}
          mouseEvents={false}
          provider={osm}
          touchEvents={false}
        >
          <Marker
            anchor={position}
            color="var(--color-negative)"
            hover={false}
          />
        </Map>
      </div>
    </div>
  );
};

MapCell.propTypes = {
  value: PropTypes.shape({ longitude: PropTypes.number, latitude: PropTypes.number }),
  height: PropTypes.any,
};

MapCell.defaultProps = {
  value: undefined,
  height: '100px',
};
